import { formatNumber } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-curmonthproduction",
  templateUrl: "./curmonthproduction.component.html",
  standalone: false,
})
export class CurMonthProductionComponent {
  @Input() public curMonthProduction: number;
  public getCurMonthProduction(): string {
    return formatNumber(this.curMonthProduction / 1000, "en", "1.0-1")+ " kWh";
  }
}
